import { action, computed, observable, runInAction } from 'mobx';
import type { RootStore } from '~/stores/root.store';
import { UiPersistence } from '~/types/angular.types';
import { Leaves } from '~/types/app.types';

export class OtamStore {
    @observable stage: 'duringMigration' | 'finishMigration' | null = null;

    @computed
    get userData() {
        return this.rootStore.uiPersistenceStore.get('otamMigration', {});
    }
    rootStore: RootStore = null;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        document.addEventListener(
            'otam_migration_stage_update',
            (
                e: CustomEvent<{ stage: 'duringMigration' | 'finishMigration' }>
            ) => {
                runInAction(() => {
                    this.stage = e.detail.stage;
                });
            }
        );
    }

    @action.bound
    _markAsChecked<T extends Leaves<UiPersistence['otamMigration']>>(key: T) {
        this.rootStore.uiPersistenceStore.set(
            `otamMigration.${key}`,
            true as any
        );
    }
    @action.bound
    getTooltipStatus(name, count) {
        return !this.userData[name] || +this.userData[name] < count;
    }

    @action.bound
    markTourAsChecked(
        contentType: keyof UiPersistence['otamMigration']['builderTourSeen']
    ) {
        this._markAsChecked(`builderTourSeen.${contentType}`);
    }

    @action.bound
    markAfterMigrationModalAsChecked() {
        this._markAsChecked('AfterMigrationModal');
    }

    @action.bound
    markAfterMigrationBannerAsChecked() {
        const { uiPersistenceStore } = this.rootStore;
        const key = 'otamMigration.afterMigrationBanner';
        const prev = uiPersistenceStore.get(key, 1);
        uiPersistenceStore.set(key, prev + 1);
    }

    @action.bound
    markCreateFolderTooltipAsChecked() {
        this._markAsChecked('newFolderTooltip');
    }

    @action.bound
    hasSeenElement(elementName: keyof UiPersistence['otamMigration']) {
        return !!this.userData[elementName];
    }

    @action.bound
    getModalVariation() {
        if (!this.userData.builderTourSeen) {
            return 'builder';
        }
        return 'action';
    }

    isMidMigration() {
        return this.stage === 'duringMigration';
    }

    currUserHasOtamVariation() {
        const {
            configStore,
            userStore: { currUser }
        } = this.rootStore;
        if (configStore.isE2E() || configStore.isTest()) {
            return false;
        }

        return !!currUser.account?.otam_group;
    }

    isMigrationEnabledExp() {
        const {
            configStore,
            userStore: { currUser }
        } = this.rootStore;

        if (configStore.isE2E() || configStore.isTest()) {
            return false;
        }
        const isMigrationEnabled = !!currUser.account?.otam_group;
        const hasOnlyFiles = !currUser.flowsBetaUserType.hasFlows;
        return (
            hasOnlyFiles &&
            isMigrationEnabled &&
            this.stage !== 'duringMigration'
        );
    }
}
